import React, { useState } from "react";
// import DigitalMarketingImg from "../../assets/digital-marketing.svg";
import "./services.css";

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <>
      <section className="services section" id="services">
        <h2 className="section__title">Services</h2>
        <span className="section__subtitle">What i offer.</span>

        <div className="services__container container grid">
          <div className="services__content">
            <div>
              <i className="uil uil-web-grid services__icon"></i>
              <h3 className="services__title">
                Full Stack <br /> Development
              </h3>
            </div>

            <span className="services__button" onClick={() => toggleTab(1)}>
              View More
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 1
                  ? "services__model active__model"
                  : "services__model"
              }
            >
              <div className="services__model-content">
                <i
                  onClick={() => toggleTab(0)}
                  className="uil uil-times services__model-close"
                ></i>

                <h3 className="services__model-title">
                  Full Stack Developer
                </h3>
                <p className="services__model-description">
                  Architecting scalable, user-centric systems from secure multi-tenant SaaS platforms to enterprise ecosystems.
                </p>

                <ul className="services__model-section grid">
                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Developing scalable RESTful APIs with Spring Boot & Node.js.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Building high-performance frontends using Next.js & React.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Engineering secure multi-tenant SaaS architectures.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Implementing clean architecture and database optimization.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Integrating payment gateways (PayHere) and third-party APIs.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="services__content">
            <div>
              <i className="uil uil-mobile-android services__icon"></i>
              <h3 className="services__title">
                Mobile App <br /> Development
              </h3>
            </div>

            <span className="services__button" onClick={() => toggleTab(2)}>
              View More
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 2
                  ? "services__model active__model"
                  : "services__model"
              }
            >
              <div className="services__model-content">
                <i
                  onClick={() => toggleTab(0)}
                  className="uil uil-times services__model-close"
                ></i>

                <h3 className="services__model-title">Mobile App Developer</h3>
                <p className="services__model-description">
                  Building high-performance mobile ecosystems with real-time sync and seamless user experiences.
                </p>

                <ul className="services__model-section grid">
                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Native Android development using Java & XML.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Cross-platform apps with React Native & Expo.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Real-time features with Firebase & bidirectional sync.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Google Maps API integration for location services.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Optimizing mobile performance for 60 FPS rendering.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="services__content">
            <div>
              <i className="uil uil-layer-group services__icon"></i>
              <h3 className="services__title">
                Digital Strategy <br /> & UI/UX
              </h3>
            </div>

            <span className="services__button" onClick={() => toggleTab(3)}>
              View More
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 3
                  ? "services__model active__model"
                  : "services__model"
              }
            >
              <div className="services__model-content">
                <i
                  onClick={() => toggleTab(0)}
                  className="uil uil-times services__model-close"
                ></i>

                <h3 className="services__model-title">Digital Strategist</h3>
                <p className="services__model-description">
                  Combining technical expertise with business acumen to elevate brand presence and user experience.
                </p>

                <ul className="services__model-section grid">
                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Modern UI/UX design and prototyping using Figma.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Data-driven Social Media Consulting & Ad Campaigns.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      AI-Accelerated development for rapid prototyping.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Strategic branding and digital presence management.
                    </p>
                  </li>

                  <li className="services__model-service">
                    <i className="uil uil-check-circle services__model-icon"></i>
                    <p className="services__model-info">
                      Technical communication and developer community building.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
